import React from 'react';
import './style.scss';
var ImageGrid = function ImageGrid(_ref) {
  var _ref$items = _ref.items,
    items = _ref$items === void 0 ? [] : _ref$items;
  if (items.length < 2) {
    return null;
  }
  var visibleItems = items.slice(0, 5);
  return /*#__PURE__*/React.createElement("div", {
    className: "ImageGrid ImageGrid--size-".concat(visibleItems.length)
  }, visibleItems.map(function (item, index) {
    return (
      /*#__PURE__*/
      // eslint-disable-next-line react/no-array-index-key
      React.createElement("div", {
        key: index
      }, item)
    );
  }));
};
export default ImageGrid;